import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

/** DB match.date + match.time are kickoff wall clock in Madrid. */
export const MATCH_KICKOFF_TIMEZONE = 'Europe/Madrid'

function normalizeMatchTime(time?: string | null): string {
  const raw = time != null ? String(time).trim() : ''
  if (!raw) return '00:00:00'
  if (/^\d{1,2}:\d{2}$/.test(raw)) return `${raw}:00`
  if (/^\d{1,2}:\d{2}:\d{2}$/.test(raw)) return raw
  return '00:00:00'
}

function getMatchDateStr(date: string | Date): string {
  if (date instanceof Date) return dayjs(date).format('YYYY-MM-DD')
  return String(date).split('T')[0]
}

export function getMatchKickoffDayjs(match: { date: string; time?: string | null }) {
  const dateStr = getMatchDateStr(match.date)
  const timeStr = normalizeMatchTime(match.time)
  return dayjs.tz(`${dateStr}T${timeStr}`, MATCH_KICKOFF_TIMEZONE)
}

/**
 * Kickoff instant as ISO UTC string (for comparisons, sorting, prediction hiding).
 */
export const getMatchDate = (
  match: { date: string; time?: string | null },
  includeTime: boolean = true,
): string => {
  if (!match?.date) return new Date().toISOString()

  const dateStr = getMatchDateStr(match.date)
  if (!includeTime) return dateStr

  return getMatchKickoffDayjs(match).toISOString()
}

/**
 * Format kickoff for display in the user's local timezone.
 */
export const formatDate = (dateString: string, includeTime: boolean = true): string => {
  const parsed = dayjs(dateString)
  if (!parsed.isValid()) return dateString

  if (includeTime) {
    return parsed.format('MMM D, YYYY, HH:mm')
  }

  return parsed.format('MMM D, YYYY')
}

/** Room chat: day + time, e.g. "Sun, 5 Jul · 16:53" */
export function formatChatMessageTime(iso: string): string {
  const parsed = dayjs(iso)
  if (!parsed.isValid()) return ''
  return parsed.format('ddd, D MMM · HH:mm')
}
